<!--
 * @Description: 下载中心
 * @Author: 杨帆
-->
<template>
  <div class="download-center">
    <x-page>
      <!--数据面板-->
      <x-data v-show="tableData.length > 0 && !loading">
        <!--数据面板按钮插糟-->
        <template #tool>
          <el-row type="flex" class="tools" justify="end">
            <el-button size="small" style="margin-right: 6px; padding: 8px 10px" @click="loadData">
              <em class="el-icon-refresh-right text-16px" />
              刷新列表
            </el-button>
            <el-button size="small" type="danger" style="margin-right: 6px; padding: 8px 10px" @click="clearFiles">
              <em class="el-icon-delete text-16px" />
              清空列表
            </el-button>
          </el-row>
        </template>
        <div class="file-list" v-loading="loading">
          <div class="file-item" v-for="item in tableData" :key="item.id">
            <div class="file-item-icon">
              <x-file-icon :type="item.fileType"></x-file-icon>
            </div>
            <div class="file-item-l">
              <div class="file-item-top">
                <span class="file-name">{{ item.fileName }}</span>
              </div>
              <div class="file-item-bottom">
                <span class="file-item-create-time">{{ item.requestTime }}</span>
                <span class="file-tag">
                  <el-tag size="small">{{
                    selectDictLabel(dictOptions['t_download_record.app_sign'], item.appSign + '')
                  }}</el-tag>
                </span>
              </div>
            </div>
            <div class="file-item-r">
              <span class="color-proceed" v-if="item.state === 1">进行中</span>
              <el-button
                type="text"
                v-if="item.state === 2"
                @click="downloadFile(item.filePath, item.fileName, item.fileType)"
                >下载</el-button
              >
              <span class="color-failed" v-if="item.state === 3">失败</span>
            </div>
          </div>
        </div>
        <div class="pagination-content">
          <XPagination :total="pagination.total" @pagination="onPageChange"></XPagination>
        </div>
      </x-data>
      <el-empty v-show="tableData.length === 0 && !loading" style="height: 100%"></el-empty>
    </x-page>
  </div>
</template>
<script>
  import { QueryDictMixin, TableListMixin } from '@main/common/mixins/index.js'
  import { buttonIcons } from '@main/common/utils/buttonIcon.js'
  import { exportFileDownload, selectDictLabel } from '@package/utils'
  import { listUrl, apiDeleteByUserId } from '../api/downloadCenter.js'
  import { EnumApiCode } from '../../../../../../globalEnum.js'

  export default {
    mixins: [TableListMixin, QueryDictMixin],
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        listUrl,
        tableData: [],
        pagination: {
          pageSize: 10,
          pageNum: 1,
          total: 0
        },
        dictKeys: ['t_download_record.app_sign']
      }
    },
    watch: {
      isShow(val) {
        if (val) {
          this.loadData()
        }
      }
    },
    methods: {
      buttonIcons,
      selectDictLabel,
      onPageChange(val) {
        this.pagination = {
          ...this.pagination,
          ...val
        }
        this.loadData()
      },
      async clearFiles() {
        this.$confirm('是否确定清空所有下载文件?', '提示', {
          confirmButtonText: this.$t('common.sure'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(async () => {
          const { code } = await apiDeleteByUserId()
          if (code === EnumApiCode.Success) {
            this.$message.success('清空成功!')
            await this.loadData()
          }
        })
      },
      async downloadFile(filePath, fileName, fileType) {
        exportFileDownload({
          url: '/file/operation/downloadFile',
          filePath,
          fileName,
          fileType
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../common/assets/style/variables';

  .download-center {
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
  }
  ::v-deep .x-data-view {
    margin-top: 0;
    padding: 0;
    border: none;
  }

  .file-list {
    overflow-y: auto;
    height: calc(100% - 50px);
    padding: 0 20px;
  }

  .file-item {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    padding: 10px 0;
    border-top: 1px solid #ebeef5;
  }

  .file-item:last-child {
    border-bottom: 1px solid #ebeef5;
  }

  .file-item-bottom {
    display: flex;
    align-items: center;

    .file-tag {
      min-width: 60px;
    }

    .file-item-create-time {
      font-size: 14px;
      margin-right: 20px;
      color: #818794;
    }
  }

  .file-item-icon {
    display: flex;
    align-items: center;
  }

  .file-item-l {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding-left: 10px;
  }

  .file-item-r {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 40px;
    padding-right: 10px;
  }

  .file-name {
    font-size: 14px;
    color: #606266;
  }

  .pagination-content {
    padding: 0 20px;
  }

  .color-proceed {
    color: #ff993c;
  }

  .color-failed {
    color: #f55248;
  }
</style>
